import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the table bets report view.
 * @extends JetView
 */
export default class tableBetsReportView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const id_partner = this.getParam('partner', true); // Retrieving partner ID from parameters

        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'datatable', // DataTable view
                            id: 'datatable', // ID of the DataTable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            scheme: {
                                // Data scheme configuration (empty in this case)
                            },
                            scrollY: true, // Enable vertical scrolling
                            height: screen.width < 820 ? 420 : 0, // Conditional height based on screen width
                            columns: [
                                {
                                    id: 'Date', // Column ID
                                    header: _('Fecha Creación'), // Column header with localization
                                    width: 200, // Column width
                                    template: function (obj, common) {
                                        // Template function for rendering cell content
                                        if (obj.$group) return common.datatable(obj, common) + obj.value;
                                        return obj.Date; // Return the date value
                                    },
                                    footer: 'Total:', // Footer text
                                },
                                {
                                    id: 'detailTittle', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Detalles'), // Tooltip text with localization
                                    template: function (obj) {
                                        // Template function for rendering cell content
                                        if (obj.$level == 1) {
                                            return ''; // Return empty for level 1
                                        } else {
                                            return "<span class='webix_icon wxi-close details'></span>"; // Return icon for details
                                        }
                                    },
                                    footer: _('Total:'), // Footer text with localization
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: _('Ticket Id'), // Column header with localization
                                    width: 100, // Column width
                                },
                                {
                                    id: 'BetShop', // Column ID
                                    header: _('Punto de Venta'), // Column header with localization
                                    width: 150, // Column width
                                },
                                {
                                    id: 'DatePayment', // Column ID
                                    header: _('Fecha de pago'), // Column header with localization
                                    width: 150, // Column width
                                },
                                {
                                    id: 'BetShopPayment', // Column ID
                                    header: _('Punto Venta Pagó'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Cashier', // Column ID
                                    header: _('Cajero'), // Column header with localization
                                    width: 150, // Column width
                                },
                                {
                                    id: 'UserId', // Column ID
                                    header: _('Usuario Id'), // Column header with localization
                                    width: 80, // Column width
                                },
                                {
                                    id: 'UserName', // Column ID
                                    header: _('Usuario'), // Column header with localization
                                    width: 150, // Column width
                                },
                                {
                                    id: 'State', // Column ID
                                    header: _('Estado'), // Column header with localization
                                    width: 80, // Column width
                                    options: [
                                        // Options for the state column
                                        { id: 'C', value: _('Abierto') },
                                        { id: 'S', value: _('Ganó') },
                                        { id: 'N', value: _('Perdió') },
                                        { id: 'A', value: _('No Acción') },
                                        { id: 'R', value: _('Pendiente') },
                                        { id: 'W', value: _('En Espera') },
                                        { id: 'J', value: _('Rechazada') },
                                        {
                                            id: 'M',
                                            value: _('Rechazada por Regla'),
                                        },
                                        {
                                            id: 'T',
                                            value: _('Retiro Voluntario'),
                                        },
                                    ],
                                },
                                {
                                    id: 'Date', // Column ID
                                    header: _('Fecha Creación'), // Column header with localization
                                    width: 150, // Column width
                                },
                                {
                                    id: 'Amount', // Column ID
                                    header: _('Valor'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    footer: { content: 'summColumn' }, // Footer configuration
                                },
                                {
                                    id: 'WinningAmount', // Column ID
                                    header: _('Premios'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    footer: { content: 'summColumn' }, // Footer configuration
                                },
                                {
                                    id: 'Tax', // Column ID
                                    header: _('Impuesto'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    footer: { content: 'summColumn' }, // Footer configuration
                                },
                                {
                                    id: 'WinningAmountTotal', // Column ID
                                    header: _('Premio Total'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    footer: { content: 'summColumn' }, // Footer configuration
                                },
                                { id: 'Odds', header: _('Odds'), width: 100 }, // Column for Odds
                                { id: 'UserIP', header: 'IP', width: 150 }, // Column for User IP
                            ],
                            onClick: {
                                details: function (euv, id) {
                                    // Event handler for clicking on details
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('user:id', [
                                        item.Id, // Call event with user ID
                                    ]);
                                    $$('dColl').expand(); // Expand details section
                                    $$('a5').scrollTo(0, 1000); // Scroll to specific position
                                },
                            },
                            on: {
                                onBeforeLoad: function () {
                                    // Event handler before loading data
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                onAfterLoad: function () {
                                    // Event handler after loading data
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                // Event handler when the DataTable is ready
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox); // Extend with OverlayBox
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // Show no data overlay
                                            '</div>',
                                    );
                                }
                            },
                            footer: false, // Disable footer
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        const id_partner = this.getParam('partner', true); // Retrieve partner ID
        var gridppal = $$('datatable'); // Reference to the main DataTable
        var url = devConfig.geturlApi() + 'null/Report/GetBetHistory?Partner=' + id_partner + '&'; // API URL for fetching bet history
        var filter = ''; // Filter string for API requests
        const _ = this.app.getService('locale')._; // Localization service
        var flag = false; // Flag for export operation

        // Event handler for filtering data
        this.on(this.app, 'casinoReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // String for date filters
            var string2 = ''; // String for sorting filters

            // Loop through filter data entries
            for (var i = 0; i < object.length; i++) {
                if (object[i][0] == 'Sort') {
                    // Handle sorting
                    if (object[i][1] == '1') {
                        string2 = string2 + '&sort[Date]=';
                    } else {
                        if (object[i][1] == '2') {
                            string2 = string2 + '&sort[UserId]=';
                        } else {
                            if (object[i][1] == '3') {
                                string2 = string2 + '&sort[Amount]=';
                            }
                        }
                    }
                }
                if (object[i][0] == 'Dir') {
                    // Handle sorting direction
                    if (object[i][1] == '0') {
                        string2 = string2 + 'asc';
                    } else {
                        if (object[i][1] == '1') {
                            string2 = string2 + 'desc';
                        }
                    }
                }
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle date filters
                    if (object[i][0] == 'DateStart') {
                        var date = object[i][1].split(' - ');
                        console.log(date); // Log date for debugging
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] == 'DateEnd') {
                            var date = object[i][1].split(' - ');
                            console.log(date); // Log date for debugging
                            string1 = string1 + '&dateFrom2=' + date[0];
                            string1 = string1 + '&dateTo2=' + date[1];
                        } else {
                            if (
                                object[i][0] != 'Sort' &&
                                object[i][0] != 'Dir' &&
                                object[i][0] != 'Date' &&
                                object[i][0] != 'Date2'
                            ) {
                                string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                            } else {
                                if (object[i][0] == 'Date') {
                                    var date = object[i][1].replace(' 00:00:00', '');
                                    string1 = string1 + '&dateFrom=' + date;
                                    string1 = string1 + '&dateTo=' + date;
                                }
                                if (object[i][0] == 'Date2') {
                                    var date = object[i][1].replace(' 00:00:00', '');
                                    string1 = string1 + '&dateFrom2=' + date;
                                    string1 = string1 + '&dateTo2=' + date;
                                }
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Convert start date to Date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Convert end date to Date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Partner=' + id_partner; // Append partner ID to filter string
            gridppal.clearAll(); // Clear existing data in the grid
            gridppal.load(
                url + '?start=0&count=' + gridppal.data.$pagesize + string1 + string2, // Load data with filters
            );
            filter = string1 + string2; // Store the current filter
        });

        // Event handler for sorting data
        gridppal.attachEvent('onAfterSort', function (by, dir, as) {
            gridppal.load(
                url + '?start=0&count=' + gridppal.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event handler for item click
        gridppal.attachEvent('onItemClick', function (id, e, node) {
            // Placeholder for item click event
        });

        // Event handler for player selection
        this.on(this.app, 'player:select', (id) => {
            gridppal.load(
                url + '?start=0&count=' + gridppal.data.$pagesize + '&PlayerId=' + id, // Load data for selected player
            );
        });

        // Event handler for export filtering
        this.on(this.app, 'export:filter', (filterData) => {
            flag = true; // Set flag for export operation
            var firstfirst;
            if (filterData.first == 0) {
                firstfirst = filterData.first + 1; // Adjust first index for export
            } else {
                firstfirst = filterData.first; // Use original first index
            }
            gridppal.load(
                url + '?start=' + firstfirst + '&count=' + (filterData.last + 1) + filter, // Load data for export
            );
            gridppal.attachEvent(
                'onAfterLoad',
                function () {
                    if (flag) {
                        var size = gridppal.getPager().config.size; // Get pager size
                        var page = gridppal.getPage(); // Get current page
                        var first = size * page; // Calculate first item index
                        var last = first + size - 1; // Calculate last item index
                        if ($$('Export').getValue() == '1') {
                            // Export to Excel
                            for (var j = 0; j < gridppal.config.columns.length; j++) {
                                if (gridppal.config.columns[j].exportType) {
                                    delete gridppal.config.columns[j].format; // Remove format for export
                                }
                            }
                            this.app.callEvent('export:data', [
                                {
                                    NameReport:
                                        _('Apuestas') +
                                        ($$('datatable').count() > 0 ? '' : _(' - No hay datos')) +
                                        ' - ' +
                                        new Date().toLocaleString(), // Report name
                                    TypeReport: 'Excel', // Report type
                                },
                            ]);
                            webix.toExcel(gridppal, {
                                filter: function (obj) {
                                    return (
                                        gridppal.getIndexById(obj.id) >= first && gridppal.getIndexById(obj.id) <= last // Filter for exporting data
                                    );
                                },
                                filename:
                                    'Virtualsoft - ' +
                                    new Date()
                                        .toLocaleString('en-GB', {
                                            hour12: true,
                                        })
                                        .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                        .replace(/[\/:]/g, '_')
                                        .toUpperCase() +
                                    ' - ' +
                                    ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                    _('Apuestas'), // Filename for export
                                ignore: { detailTittle: true }, // Ignore specific columns
                                footer: false, // Disable footer in export
                            });
                        } else {
                            if ($$('Export').getValue() == '2') {
                                // Export to PDF
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            _('Apuestas') +
                                            ($$('datatable').count() > 0 ? '' : _(' - No hay datos')) +
                                            ' - ' +
                                            new Date().toLocaleString(), // Report name
                                        TypeReport: 'PDF', // Report type
                                    },
                                ]);
                                webix.toPDF(gridppal, {
                                    filter: function (obj) {
                                        return (
                                            gridppal.getIndexById(obj.id) >= first &&
                                            gridppal.getIndexById(obj.id) <= last // Filter for exporting data
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Apuestas'), // Filename for export
                                    autowidth: true, // Enable auto width for PDF
                                    ignore: { detailTittle: true }, // Ignore specific columns
                                    footer: false, // Disable footer in export
                                });
                            }
                        }
                        flag = false; // Reset flag after export
                        $$('Export').setValue(''); // Reset export selection
                    }
                }.bind(this), // Bind context for event handler
            );
        });
    }
}

// FILE DOCUMENTED
